"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const PT = __importStar(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const react_modal_1 = __importDefault(require("react-modal"));
const nav_frontend_lukknapp_1 = __importDefault(require("nav-frontend-lukknapp"));
require("nav-frontend-modal-style");
const cls = (className) => (0, classnames_1.default)("modal", className);
class ModalWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.onRequestClose = this.onRequestClose.bind(this);
    }
    static setAppElement(element) {
        react_modal_1.default.setAppElement(element);
    }
    onRequestClose(evt) {
        const { onRequestClose, shouldCloseOnOverlayClick } = this.props;
        if (shouldCloseOnOverlayClick || evt.type === "keydown") {
            onRequestClose();
        }
        else if (this.closeButtonRef) {
            this.closeButtonRef.focus();
        }
        else if (this.modalRef &&
            this.modalRef.portal &&
            this.modalRef.portal.refs.content) {
            this.modalRef.portal.refs.content.focus();
        }
    }
    render() {
        const _a = this.props, { children, closeButton, shouldCloseOnOverlayClick, contentClass } = _a, props = __rest(_a, ["children", "closeButton", "shouldCloseOnOverlayClick", "contentClass"]);
        const lukkModalLabel = "Lukk";
        return (React.createElement(react_modal_1.default, Object.assign({}, props, { className: cls(props.className), onRequestClose: this.onRequestClose, overlayClassName: "modal__overlay", shouldCloseOnOverlayClick: true, ref: (modalRef) => {
                this.modalRef = modalRef;
            } }),
            React.createElement("section", { className: contentClass }, children),
            closeButton && (React.createElement(nav_frontend_lukknapp_1.default, { overstHjorne: true, className: (0, classnames_1.default)({
                    "modal__lukkknapp--shake": shouldCloseOnOverlayClick,
                }), ariaLabel: lukkModalLabel, onClick: props.onRequestClose, ref: (closeButtonRef) => {
                    this.closeButtonRef = closeButtonRef;
                } }, lukkModalLabel))));
    }
}
ModalWrapper.defaultProps = {
    closeButton: true,
    shouldCloseOnOverlayClick: true,
    closeTimeoutMS: 0,
    contentClass: undefined,
    onAfterOpen: undefined,
};
ModalWrapper.propTypes = {
    /**
     * Bestemmer om modalen skal være synlig
     */
    isOpen: PT.bool,
    /**
     * En beskrivelse av formålet med modalen, blir satt som `aria-label`
     */
    contentLabel: PT.string,
    /**
     * Innholdet i modalen
     */
    children: PT.node,
    /**
     * Funksjon som blir kalt i det modalen ønsker å lukkes
     */
    onRequestClose: PT.func,
    /**
     * Bestemmer om modalen selv skal legge til en lukkeknapp
     */
    closeButton: PT.bool,
    /**
     * Funksjon som blir kalt når modalen har blitt åpnet. Kan brukes for å sette fokus på ett element
     */
    onAfterOpen: PT.func,
    /**
     * Om klikk på overlay skal lukke modalen
     */
    shouldCloseOnOverlayClick: PT.bool,
    /**
     * Tall som beskriver hvor lenge modalen venter før den lukkes
     */
    closeTimeoutMS: PT.number,
    /**
     * Klasse for content-taggen
     */
    contentClass: PT.string,
    /**
     * Klasse som legges til dialog
     */
    className: PT.string,
};
exports.default = ModalWrapper;
